<script>
import { mapGetters, mapActions } from "vuex";
import appConfig from "@/app.config";
import { debounce } from "../../../state/helpers";
import { formatIST } from "../../../config/moment";
import config from "../../../config/config";
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import moment from "moment";


export default {
  page: {
    title: "User-Wallet-Transaction",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  data() {
    return {
      config: config,
      sortBy: "id",
      perPages: 5,
      sortDesc: true,
      page: 1,
      search: "",
      formatIST,
      id: "",
      booking: {
        is_cancel: [],
      },
      typeform: {
        selectedCharger: [],
      },
      searchData: debounce(() => {
        this.getMyWalletTransaction();
        this.init = false;
      }, 500),
      chargerList: [],
      moment: moment,
      dateRange: {
        startDate: moment().startOf("day").subtract(29, "days"),
        endDate: moment(),
      },
      filters: {
        start_date: moment().startOf("day").subtract(29, "days").format("YYYY-MM-DD"),
        end_date: moment().format("YYYY-MM-DD"),
      },
      fields: [
        { key: "id", sortable: true, label: "ID" },
        { key: "full_name", sortable: false, label: "User Name" },
        { key: "description", sortable: false, label: "Description" },
        { key: "created_at", sortable: true, label: "Transaction Time" },
        { key: "source", sortable: true, label: "Method" },
        { key: "transaction_id", sortable: false, label: "Transaction Id" },
        { key: "credit", sortable: false, label: "Credit" },
        { key: "debit", sortable: false, label: "Debit" },
      ],
    };
  },
  props: ["userId"],
  components: { DateRangePicker },
  validations: {},
  computed: {
    ...mapGetters("userWallet", [
      "loading",
      "pagination",
      "walletTransactionCount",
      "walletTransactions",
      "walletAmount",
      "totalCredit",
      "totalDebit",
    ]),
  },
  mounted() {
    this.getMyWalletTransaction();
  },
  methods: {
    ...mapActions("userWallet", ["getWalletTransaction"]),
    getMyWalletTransaction(page = 1) {
      var filters = {
        ...this.filters,
        search: this.search,
        sort_by: this.sortBy,
        order_by: this.sortDesc ? "desc" : "asc",
        page: page && page > 0 ? page : 1,
        limit: this.perPages,
      };
      this.getWalletTransaction(filters);
    },
    sortingChanged(ctx) {
      this.sortBy = ctx.sortBy;
      this.sortDesc = ctx.sortDesc;
      this.getMyWalletTransaction();
    },
    convertDecodeId(id) {
      return (this.user_id = atob(id));
    },
    handleFullNameClick(item) {
      console.log("User clicked on:", item?.users?.id);
    },
    updateValues(date) {
      // Format dates
      const startDate = moment(date.startDate).format("YYYY-MM-DD");
      const endDate = moment(date.endDate).add(1, "days").format("YYYY-MM-DD"); // Include full end date

      // Update internal filter state
      this.filters = {
        ...this.filters,
        start_date: startDate,
        end_date: endDate,
      };

      // Construct the download URL and trigger it
      const downloadUrl = `${this.config.appurl}download-all-user-transactions-data/${startDate}/${endDate}`;
      window.open(downloadUrl, "_blank"); // Trigger file download in a new tab
    },
  },
};
</script>

<template>
  <div class="row">
    <div class="col-12">
      <div class="d-flex justify-content-end align-items-center mb-3 flex-wrap">
        <!-- <a :href="`${config.appurl}download-all-user-transactions-data/${filters.start_date}/${filters.end_date}`"
          class="btn btn-primary btn-md btn-rounded ml-1 mr-3">
          Download Filtered Data
        </a> -->
        <date-range-picker ref="picker" :locale-data="{ firstDay: 1, format: 'dd-mm-yyyy' }" :showDropdowns="true"
          :showWeekNumbers="true" opens="left" v-model="dateRange" class="w-250 ml-3" @update="updateValues">
          <template v-slot:input="picker">
            {{
              moment(picker.startDate.toISOString()).format("DD-MM-YYYY")
            }} - {{
              moment(picker.endDate.toISOString()).format("DD-MM-YYYY")
            }}
          </template>
        </date-range-picker>
        <a :href="config.appurl + 'download-all-user-transactions-data'"
          class="btn btn-primary btn-md btn-rounded ml-1 mr-3 ">
          Download All Data
        </a>
        <h5 class="mb-0 mr-3 card-title">Today's Debit: ₹{{ totalDebit }}</h5>
        <h5 class="mb-0 card-title">Today's Credit: ₹{{ totalCredit }}</h5>
      </div>
      <form action="#" @submit.prevent="typeForm">
        <div class="card details-profile-main">
          <div class="card-body">
            <div class="row align-items-center">
              <div class="col-md-6">
                <div class="pb-0 page-title-box d-flex align-items-center justify-content-between icon-main-page">
                  <h4 class="card-title page-title-left">
                    Transactions ({{ walletTransactionCount }})
                  </h4>
                </div>
              </div>
              <div class="col-md-6">
                <div class="row justify-content-end">
                  <div class="col-sm-6">
                    <div class="form-group">
                      <div class="date-range-list">
                        <label>Per Page :</label>
                        <select class="custom-select" v-model="perPages" @change="searchData()">
                          <option value="5" selected>5</option>
                          <option value="10">10</option>
                          <option value="25">25</option>
                          <option value="50">50</option>
                          <option value="100">100</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-5">
                    <div class="date-range-list">
                      <label>Search :</label>
                      <div class="text-sm-right">
                        <div class="search-box mr-2 d-inline-block">
                          <div class="position-relative">
                            <input type="text" class="form-control" id="search" @input="searchData()" v-model="search"
                              :placeholder="$t('navbar.search.text')" />
                            <i class="bx bx-search-alt search-icon"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <b-table striped hover :items="walletTransactions" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc"
                  :no-local-sorting="true" @sort-changed="sortingChanged" :fields="fields" :busy="loading">
                  <template #table-busy>
                    <div class="text-center text-danger my-2">
                      <b-spinner class="align-middle"></b-spinner>
                      <strong>{{ $t(" Loading") }}</strong>
                    </div>
                  </template>
                  <template v-slot:cell(created_at)="items">
                    {{ formatIST(items.item.created_at) }}
                  </template>
                  <template v-slot:cell(credit)="items">
                    <span v-if="items.item.type === 'credit'">₹{{ items.item.amount }}</span>
                  </template>
                  <template v-slot:cell(debit)="items">
                    <span v-if="items.item.type === 'debit'">₹{{ items.item.amount }}</span>
                  </template>
                  <template v-slot:cell(full_name)="items">
                    <span>
                      <router-link
                        :to="{ name: 'user-view', params: { id: base64(items.item.users.id) }, query: { isWalletHistory: true } }">{{
                          items.item.full_name }}
                      </router-link>
                    </span>
                  </template>
                </b-table>
                <tr v-if="loading == false && walletTransactions.length === 0">
                  <td colspan="100%">
                    <h6 align="center">No Booking Data Found</h6>
                  </td>
                </tr>
              </div>
              <div class="row col-sm-5 offset-sm-7">
                <div class="col">
                  <div class="dataTables_paginate paging_simple_numbers float-right">
                    <ul class="pagination pagination-rounded mb-0">
                      <pagination :data="pagination" :limit="perPages" @pagination-change-page="getMyWalletTransaction">
                      </pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>